//const serverUrl = 'http://localhost:4000';
const serverUrl = '';

export default {
	socketUrl: serverUrl,
	socketLobbyNamespace: `${serverUrl}/lobby`,
	socketGameNamespace: `${serverUrl}/game`,
	apiUrl: `${serverUrl}/api`
};
